module.exports = __webpack_public_path__ + "static/media/event.d3bdd911.svg";